import { render, staticRenderFns } from "./HeadBack.vue?vue&type=template&id=ca4ea4ba&"
import script from "./HeadBack.vue?vue&type=script&lang=js&"
export * from "./HeadBack.vue?vue&type=script&lang=js&"
import style0 from "./HeadBack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports